import { z } from "zod";
import { agentAnalyticsSchema, analyticsPeriodSchema, } from "./agent-analytics.js";
export const analyticsSettingsSchema = z
    .object({
    prompt: z.string().max(4000),
    version: z.number().int().nonnegative(),
})
    .strict();
export const analyticsSettingsWriteSchema = z
    .object({
    prompt: z.string().max(4000),
    expectedVersion: z.number().int().nonnegative(),
})
    .strict();
export const analyticsReportCreateSchema = z
    .object({
    period: analyticsPeriodSchema,
    expectedPromptVersion: z.number().int().nonnegative(),
    requestKey: z.string().uuid(),
    retryOfReportId: z.string().uuid().optional(),
})
    .strict();
export const analyticsMetricSchema = z.enum([
    "length",
    "escalations",
    "qualifiedLeads",
    "goalAchievedLeads",
]);
const text = (max) => z.string().trim().min(1).max(max);
export const analyticsInsightSchema = z
    .object({
    metric: analyticsMetricSchema,
    observation: text(1000),
    hypothesis: text(1000).nullable(),
})
    .strict();
export const analyticsNarrativeSchema = z
    .object({
    summary: text(2000),
    insights: z.array(analyticsInsightSchema).max(8),
    recommendations: z.array(text(800)).max(5),
    limitations: z.array(text(500)).max(8),
    unavailableMetrics: z.array(text(500)).max(8),
})
    .strict();
export const analyticsComparisonSchema = z
    .object({
    metric: analyticsMetricSchema,
    absoluteDelta: z.number().finite().nullable(),
    percentChange: z.number().finite().nullable(),
    reason: z.enum(["NO_BASELINE", "PARTIAL_COVERAGE"]).nullable(),
})
    .strict();
export const analyticsReportStatusSchema = z.enum([
    "QUEUED",
    "RUNNING",
    "COMPLETED",
    "FAILED",
    "UNKNOWN",
    "CANCELLED",
]);
export const analyticsReportSchema = z
    .object({
    id: z.string().uuid(),
    status: analyticsReportStatusSchema,
    createdAt: z.string().datetime(),
    completedAt: z.string().datetime().nullable(),
    snapshot: agentAnalyticsSchema,
    promptSnapshot: z.string().max(4000),
    promptVersion: z.number().int().nonnegative(),
    narrative: analyticsNarrativeSchema.nullable(),
    errorCode: z.string().nullable(),
    retryOfReportId: z.string().uuid().nullable(),
    comparisons: z.array(analyticsComparisonSchema).length(4).optional(),
})
    .strict();
export const analyticsReportListItemSchema = z
    .object({
    id: z.string().uuid(),
    status: analyticsReportStatusSchema,
    period: analyticsPeriodSchema,
    createdAt: z.string().datetime(),
})
    .strict();
export const analyticsReportPageSchema = z
    .object({
    items: z.array(analyticsReportListItemSchema).max(50),
    nextCursor: z.string().nullable(),
})
    .strict();
//# sourceMappingURL=analytics-report.js.map